import { useTranslation } from 'react-i18next';

export interface CalculatedAtCaptionProps {
  /** ISO 8601 timestamp (FR48 — backend is language-neutral, frontend formats per locale). */
  isoDate: string;
  className?: string;
}

/**
 * FR25/EXPERIENCE.md State Patterns: "Berekendatum/versheid: Caption 'berekend op {datum}'".
 * The single shared component every completeness-view in E4 uses — never a per-screen string
 * (h4-2 implementation note).
 */
export function CalculatedAtCaption({ isoDate, className }: CalculatedAtCaptionProps) {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage ?? i18n.language;
  const formatted = new Date(isoDate).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  return (
    <p
      data-testid="calculated-at-caption"
      className={className}
      style={{ fontSize: '0.75rem', color: 'var(--foreground-muted)' }}
    >
      {t('dataQuality.calculatedAt', { date: formatted })}
    </p>
  );
}
